
import { useState, useEffect } from 'react';
import { useAuth } from '@/context/AuthContext';
import { supabase } from '@/integrations/supabase/client';

export const useOnboarding = () => {
  const { user, profile } = useAuth();
  const [showOnboarding, setShowOnboarding] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkOnboardingStatus = async () => {
      if (!user) {
        setLoading(false);
        return;
      }

      try {
        // Check if user has completed onboarding (has a name set)
        const { data: profileData, error } = await supabase
          .from('profiles')
          .select('name, daily_focus_target')
          .eq('id', user.id)
          .single();

        if (error) {
          console.error('Error checking profile:', error);
          setLoading(false);
          return;
        }

        // Show onboarding if name is not set
        const needsOnboarding = !profileData?.name?.trim();
        setShowOnboarding(needsOnboarding);
      } catch (error) {
        console.error('Error:', error);
      } finally {
        setLoading(false);
      }
    };

    checkOnboardingStatus();
  }, [user, profile]);

  const completeOnboarding = () => {
    setShowOnboarding(false);
    // Force a refresh of the auth state to get the updated profile
    window.location.reload();
  };

  return {
    showOnboarding,
    completeOnboarding,
    loading
  };
};
